<template>
    <div>
        <h4 class="subtitle is-6 mb-5">
            Listed below are the jobs that have been assigned to this property.
        </h4>

        <Notification v-if="worksOrders && ! hasWorksOrders">
            No works orders found.
        </Notification>

        <div
            v-else
            class="table-container"
        >
            <table class="table is-fullwidth is-bordered is-striped">
                <thead
                    v-if="! worksOrders || hasWorksOrders"
                    class="is-hidden-mobile"
                >
                    <tr>
                        <th>
                            Date
                        </th>
                        <th>
                            Description
                        </th>
                        <th v-if="! $meta.features.owners.works_orders_hide_estimate">
                            Estimate (&pound;)
                        </th>
                        <th>
                            Status
                        </th>
                        <th>
                            Date Completed
                        </th>
                    </tr>
                </thead>
                <thead
                    v-if="! worksOrders || hasWorksOrders"
                    class="is-hidden-tablet"
                >
                    <tr>
                        <th>
                            Date & Description
                        </th>
                        <th v-if="! $meta.features.owners.works_orders_hide_estimate">
                            Estimate (&pound;)
                        </th>
                    </tr>
                </thead>
                <tbody v-if="hasWorksOrders">
                    <WorksOrderRow
                        v-for="row in worksOrders.Rows"
                        :key="row.TransactionPK"
                        :row="row"
                    />
                </tbody>
                <SkeletonRow
                    v-if="! worksOrders && ! hasWorksOrders"
                    :row-count="($meta.features.owners.works_orders_hide_estimate ? 4 : 5)"
                    :desktop-count="($meta.features.owners.works_orders_hide_estimate ? 4 : 5)"
                    :tablet-count="($meta.features.owners.works_orders_hide_estimate ? 4 : 5)"
                    :mobile-count="2"
                />
            </table>
        </div>

        <b-pagination
            v-if="hasWorksOrders && worksOrders.RowCount > limit"
            class="mt-3"
            :total="worksOrders.RowCount"
            :current.sync="page"
            order="is-centered"
            range-before="2"
            range-after="2"
            :per-page="limit"
            @change="searchWorksOrders(false)"
        />
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import Notification from './Notification.vue';
import SkeletonRow from './SkeletonRow.vue';
import WorksOrderRow from './WorksOrderRow';

export default {
    components: {
        Notification,
        SkeletonRow,
        WorksOrderRow,
    },

    data: function() {
        return {
            page: Number(this.$route.query.page || 1),
            limit: 12,
        };
    },

    computed: {
        ...mapState('portfolioProperty', [
            'property',
        ]),
        ...mapState('worksOrders', [
            'worksOrders',
        ]),
        ...mapGetters('worksOrders', [
            'hasWorksOrders',
        ]),
    },

    mounted() {
        this.getWorksOrders();
    },

    methods: {
        searchWorksOrders(resetPagination = true) {
            if (resetPagination) {
                this.page = 1;
            }

            this.$router.push({
                query: this.$data,
            });

            this.getWorksOrders();
        },
        getWorksOrders() {
            this.$store.dispatch('worksOrders/getWorksOrders', {
                propertyPK: this.property.PropertyPK,
                ...this.$data,
            });
        },
    },
};
</script>
